<template>
  <div class="mall-commodityGoods-detail">
      <div class="main" @scroll="scrollEvent" ref="scrollArea">
        <div class="top">
          <div
            class="top-img"
            v-if="obj.coverMap && obj.coverMap.url"
            :style="`background-image: url('${obj.coverMap.url}');`"
          ></div>
          <div class="top-info">
            <div class="info-box">
              <div class="product-name van-multi-ellipsis--l2">{{ obj.commodityName }}</div>
            </div>
          </div>
          <div class="product-price-name" v-if="obj.goodsName">{{ obj.goodsName }}</div>
          <div class="price-info">
            <div class="price" v-if="obj.commodityPriceItemList">
              <span style="font-size: 14px">¥</span>
              <span>{{ (obj.commodityPriceItemList.length == 1 ? obj.commodityPriceItemList[0].price : obj.minPrice) | formatNumber}}</span
              >&nbsp;
              <span class="price-unit" v-if="obj.commodityPriceItemList.length > 1">起</span>
            </div>
          </div>
          <div class="jifen" v-if="obj.enableMemberPoint">可积分抵扣</div>
        </div>
        <div class="section">
          <div class="section-title">物品信息</div>
          <div class="section-detail" v-if="obj.campusList&&obj.campusList.length>0">
            <div class="class-info">
              <span class="info-left">领取地点：</span>
              <span class="info-right">{{ obj.campusList.map(i=>i.name).join('、') }}</span>
            </div>
          </div>
        </div>
        <div
          class="section"
          v-if="isEmptyContent(obj)"
        >
          <div class="section-title">物品详情</div>
          <div class="section-detail">
            <vx-mult-input-show :list="obj.detailContent.list"></vx-mult-input-show>
          </div>
        </div>
        <div class="section" v-else>
          暂无物品介绍
        </div>
      </div>
      <div class="scroll-menu" :style="'opacity:' + menuOpacity">
        <div
          class="menu-box"
          @click="toAppointPage(index)"
          v-for="(item, index) in pageList"
          :key="item"
        >
          <div :class="{ active: currentPage === item }" style="display: inline-block">
            <div class="menu-ico">
              <van-icon
                name="location-o"
                color="#FF7837"
                v-if="currentPage === item"
                size="16"
                style="vertical-align: text-top"
              />
            </div>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'mall-commodityGoods-detail',
  props: {
    obj: {
      type: Object,
  		default: {},
    }
  },
  data() {
    return {
      pageList: ['物品', '物品信息', '物品详情'],
      currentPage: '物品',
      menuOpacity: 0,
    };
  },
  methods: {
    isEmptyContent(obj) {
      return obj.detailContent && obj.detailContent.list && obj.detailContent.list.some(item=>{
        return item.type !== 'text' || (item.type == 'text' && item.content.trim() !== '');
      });
    },
    scrollEvent(e) {
      const scrollTop = e.target.scrollTop;
      this.menuOpacity = scrollTop / 200;
      if (scrollTop < 310) {
        this.currentPage = '物品';
      } else if (scrollTop >= 450) {
        this.currentPage = '物品详情';
      } else {
        this.currentPage = '物品信息';
      }
    },
    toAppointPage(index) {
      if (index === 0) {
        this.$refs.scrollArea.scrollTo(0, 0);
      } else if (index === 1) {
        this.$refs.scrollArea.scrollTo(0, 310);
      } else {
        this.$refs.scrollArea.scrollTo(0, 450);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mall-commodityGoods-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .jifen {
    display: inline-block;
    margin: 0 calc(var(--gap) * 16);
    padding: 0 4px;
    border-radius: 2px;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    background: rgba(255, 116, 55, 0.12);  
    color: #FF7437;
  }

  .main {
    flex: 1;
    overflow-y: auto;
    .top {
      background-color: var(--white);
      margin-bottom: calc(var(--gap) * 8);
      padding-bottom: calc(var(--gap) * 16);
      .top-img {
        width: 100%;
        height: 0;
        padding-top: 75%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
      }
      .top-info {
        margin: calc(var(--gap) * 16) 0 calc(var(--gap) * 6) calc(var(--gap) * 16);
        display: flex;
        justify-content: space-between;
        align-items: top;
        .info-box {
          flex: 1;
          .product-name {
            font-size: var(--fs-lg);
            font-weight: var(--bold);
          }
          .product-date {
            margin-top: calc(var(--gap) * 8);
            color: var(--g6);
            font-size: var(--fs-sm);
          }
        }
      }
      .price-info {
        padding: 0 calc(var(--gap) * 16);
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        .price {
          color: var(--c5);
          font-size: var(--fs-ex1);
          display: flex;
          align-items: baseline;
          .price-unit {
            font-size: var(--fs-xs);
            color: var(--g6);
          }
        }
      }
      .product-price-name {
        padding: 0 calc(var(--gap) * 47) calc(var(--gap) * 2)
          calc(var(--gap) * 16);
        color: var(--g6);
      }
    }
    .section {
      background-color: var(--white);
      margin-bottom: calc(var(--gap) * 8);
      padding: calc(var(--gap) * 16);
      .section-title {
        font-size:var(--fs-lg);
        font-weight: var(--bold);
      }
      .section-detail {
        margin: calc(var(--gap) * 16) 0 calc(var(--gap) * 8) 0;
        .teacher-info {
          display: flex;
          .teacher-item {
            display: flex;
            align-items: center;
            margin-right: calc(var(--gap) * 16);
            font-size: var(--fs-sm);
            .teacher-photo {
              width: calc(var(--w) * 32);
              height: calc(var(--w) * 32);
              border-radius: 50%;
              margin-right: 8px;
              background: var(--g4);
            }
            .teacher-name {
              color: var(--g7);
            }
            .teacher-role {
              color: var(--g6);
            }
            .item-right {
              margin-left: calc(var(--gap) * 8);
              color: var(--g6);
            }
          }
        }
        .class-info {
          display: flex;
          // :not(:last-child) {
          //   margin-bottom: calc(var(--gap) * 16);
          // }
          .info-left {
            color: var(--g6);
          }
          .info-right {
            flex: 1;
            color: var(--g6);
            line-height: calc(var(--w) * 22);
          }
        }
      }
    }
  }
  .scroll-menu {
    position: absolute;
    height: calc(var(--w) * 44);
    line-height: calc(var(--w) * 44);
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    background-color: var(--white);
    text-align: center;
    color: var(--g6);
    box-shadow: 0px -2px 12px 0px rgba(100, 101, 102, 0.12);
    .menu-box {
      flex: 1;
      .active {
        color: var(--c1);
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          height: calc(var(--w) * 3);
          background-color: var(--c1);
          left: 0;
          right: 0;
        }
      }
      .menu-ico {
        display: inline-block;
        width: calc(var(--w) * 16);
      }
    }
  }
}
</style>
